import { useEffect, useState } from 'react'

// Largeur de fenêtre utilisable dans le rendu SANS casser l'hydratation
// (04/11/2026). Les pages sont prérendues par scripts/snapshot.js dans un
// Chrome de 800 px de large (fenêtre par défaut de puppeteer) : au premier
// rendu d'une page prérendue, on renvoie donc 800 pour que React retrouve le
// même HTML, puis la vraie largeur juste après (et à chaque redimensionnement).
// Avant, window.innerWidth était lu directement dans le JSX : sur mobile et sur
// grand écran, React jetait tout le HTML prérendu et redessinait la page.
const LARGEUR_SNAPSHOT = 800
const PRERENDU = typeof document !== 'undefined' && !!document.getElementById('root')?.hasChildNodes()
let hydratationFaite = false

export default function useLargeur() {
    const [largeur, setLargeur] = useState(() =>
        (PRERENDU && !hydratationFaite) ? LARGEUR_SNAPSHOT : window.innerWidth)
    useEffect(() => {
        hydratationFaite = true
        const maj = () => setLargeur(window.innerWidth)
        maj()
        window.addEventListener('resize', maj)
        return () => window.removeEventListener('resize', maj)
    }, [])
    return largeur
}
